<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-layout column>
          <v-data-table
            dense
            :headers="headers"
            :items="expensesListValue"
            :items-per-page=5
          >
            <template v-slot:item.amount="{ item }">
              {{ item.amount | currency }} {{ item.expenseAmountTypeId | getExpenseAmountType }}
            </template>
            <template v-slot:item.expenseTypeId="{ item }">
              {{ item.expenseTypeId | getExpenseTypeLabel }}
            </template>
            <template v-slot:item.active="{ item }" v-if="showActive">
              <v-simple-checkbox
                v-model="item.active"
                disabled
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                v-if="showEditButton && !readonly"
                class="mx-1 my-1"
                color="primary"
                outlined
                @click="editExpenseHandler(item)"
              >
                <v-icon color="primary">edit</v-icon>
              </v-btn>
              <v-btn
                v-if="showDeleteButton && !readonly"
                class="mx-1 my-1"
                color="red"
                outlined
                @click="deleteExpenseHandler(item)"
              >
                <v-icon color="red">delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-layout>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: [
    'expensesList',
    'showEditButton',
    'showDeleteButton',
    'readonly',
    'showActive'
  ],
  computed: {
    expensesListValue: {
      get () {
        return this.expensesList ? this.expensesList : []
      }
    },
    headers () {
      let headers = [
        { text: 'Name', value: 'expenseName', width: '30%' },
        { text: 'Amount', value: 'amount', align: 'end', width: '20%' },
        { text: 'Type', value: 'expenseTypeId', align: 'center', width: '15%' }
      ]
      if (this.showActive) {
        headers.push({ text: 'Active', value: 'active', align: 'center', sortable: false, width: '10%' })
      }
      if (!this.readonly) {
        headers.push({ text: 'Actions', value: 'action', align: 'center', sortable: false, width: '25%' })
      }
      return headers
    }
  },
  methods: {
    editExpenseHandler (item) {
      this.$emit('showEditExpenseModal', item)
    },
    deleteExpenseHandler (item) {
      this.$emit('showDeleteExpenseConfirmationDialogHandler', item.id)
    }
  }
}
</script>
